<template>
    <div class="w-100">
        <b-table
            outlined
            striped
            :items="values"
            :fields="columns"
            caption-top
            tbody-tr-class="invoice-print-body-tr"
            thead-tr-class="invoice-print-head-tr"
            class="mb-0"
            :show-empty="true"
        >
            <template v-if="tableCaption" #table-caption class="text-dark"
                ><span class="text-dark font-weight-bold">
                    {{ tableCaption }}</span
                ></template
            >
            <template #empty>
                <div class="text-center">{{ emptyText }}</div>
            </template>
        </b-table>
    </div>
</template>

<script>
export default {
    props: {
        columns: {
            type: Array,
            required: true,
        },
        values: {
            type: Array,
            required: true,
        },
        tableCaption: {
            type: String,
            default: '',
        },
        emptyText: {
            type: String,
            default: 'No Records',
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.invoice-print-body-tr) {
    td {
        font-size: 10px !important;
        padding: 0px !important;
        padding-left: 4px !important;
        padding-right: 4px !important;
    }
}

:deep(.invoice-print-head-tr) {
    th {
        font-size: 12px !important;
        padding: 0px !important;
        padding-left: 4px !important;
        padding-right: 4px !important;
    }
}
</style>
